(function () {
  const cfg = window.__vatConfig || {
    enabled: true,
    defaultOn: true,
    vatRate: 20,
    moneyFormat: "${{amount}}"
  };
  if (!cfg.enabled) return;

  const forceVatOn = document.querySelector('[data-vat-btn][data-force-vat-on="true"]') != null;
  const STORAGE_KEY = "vatToggle:on";
  const RATE = Number(cfg.vatRate) / 100;

  // --- helpers ---
  function normalizeFormat(fmt) {
    if (!fmt) return "${{amount}}";
    let s = String(fmt);
    s = s.replace(/<[^>]*>/g, "");
    s = s.replace(/&nbsp;/gi, " ");
    return s.trim();
  }

  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    const fmt = normalizeFormat(format);
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return "0";
      const rounded = (number / 100).toFixed(precision);
      const parts = rounded.split(".");
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }

    const formats = {
      amount: { p: 2, t: ",", d: "." },
      amount_no_decimals: { p: 0, t: ",", d: "." },
      amount_with_comma_separator: { p: 2, t: ".", d: "," },
      amount_no_decimals_with_comma_separator: { p: 0, t: ".", d: "," }
    };

    const match = fmt.match(placeholderRegex);
    if (!match) return fmt;
    const type = match[1];
    const f = formats[type] || formats.amount;
    const number = withDelimiters(cents, f.p, f.t, f.d);
    return fmt.replace(placeholderRegex, number);
  }

  function getState() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === null) return !!cfg.defaultOn;
    return saved === "true";
  }
  function setState(on) { localStorage.setItem(STORAGE_KEY, on ? "true" : "false"); }

  function computeCents(baseInclCents, on) {
    if (on) return Number(baseInclCents);                // incl. VAT
    return Math.round(Number(baseInclCents) / (1 + RATE)); // excl. VAT
  }

  function updatePriceNode(el, on) {
    const base = el.getAttribute("data-cents");
    if (!base) return;
    const cents = computeCents(base, on);
    el.textContent = formatMoney(cents, cfg.moneyFormat); // number only
    el.setAttribute("data-money-rendered", on ? "incl" : "excl");
  }

  // ONLY attach note to the regular price inside .price__regular
  function getRegularPriceEl(priceBlock) {
    return priceBlock.querySelector(
      ".price__regular .price-item--regular[data-money]:not(.variant-item__old-price)"
    );
  }

  function setRegularNote(priceBlock, on) {
    // remove any existing notes in this price block
    priceBlock.querySelectorAll("[data-vat-note]").forEach(n => n.remove());

    const regular = getRegularPriceEl(priceBlock);
    if (!regular) return; // nothing to label (e.g., volume pricing text path)

    const note = document.createElement("span");
    note.setAttribute("data-vat-note", "");
    note.className = "vat-note";
    note.setAttribute("aria-hidden", "true");
    note.textContent = on ? "incl. VAT" : "excl. VAT";
    regular.after(note);
  }

  function updatePriceBlock(block, on) {
    // Recompute all money nodes (regular, sale, compare-at, unit, etc.)
    block.querySelectorAll("[data-money]").forEach((el) => updatePriceNode(el, on));
    // Then attach note ONLY to the regular price in .price__regular
    setRegularNote(block, on);
  }

  function updateAllPrices(on, root = document) {
    const blocks = [];
    if (root instanceof HTMLElement && root.classList?.contains("price")) blocks.push(root);
    root.querySelectorAll?.(".price").forEach((b) => blocks.push(b));
    if (blocks.length) {
      blocks.forEach((b) => updatePriceBlock(b, on));
    } else {
      root.querySelectorAll?.("[data-money]").forEach((el) => updatePriceNode(el, on));
    }
  }

  function setToggleVisual(on) {
  document.querySelectorAll("[data-vat-btn]").forEach((btn) => {
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    const onLabel = btn.querySelector("[data-vat-on-label]");
    const offLabel = btn.querySelector("[data-vat-off-label]");
    if (onLabel && offLabel) {
      onLabel.classList.toggle("hidden", !on);
      offLabel.classList.toggle("hidden", on);
    }
  });
}

  // --- init ---
  let stateOn = forceVatOn ? true : getState();

  if (!forceVatOn) setState(stateOn); // only persist when not forced
  setToggleVisual(stateOn);
  updateAllPrices(stateOn);

  // Toggle click
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-vat-btn]");
    if (!btn) return;

    if (forceVatOn) {
      // keep it locked on
      stateOn = true;
      setToggleVisual(true);
      updateAllPrices(true);
      return;
    }

    stateOn = !stateOn;
    setState(stateOn);
    setToggleVisual(stateOn);
    updateAllPrices(stateOn);
  });

  // Watch for dynamic content & any attribute changes that may flip visibility
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === "attributes") {
        const block = m.target.closest?.(".price");
        if (block) {
          updatePriceBlock(block, stateOn);
          continue;
        }
      }
      m.addedNodes.forEach((n) => {
        if (!(n instanceof HTMLElement)) return;
        if (n.matches?.(".price, [data-money]") || n.querySelector?.(".price, [data-money]")) {
          updateAllPrices(stateOn, n);
        }
      });
    }
  });
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class", "hidden", "aria-hidden"]
  });
})();